import React, { useEffect, useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Wrapper from '../layouts/Wrapper';
import userIcon from '../assets/icons/userIcon.svg';
import messageIcon from '../assets/icons/message.svg';
import sendIcon from '../assets/icons/send.svg';
import phoneIcon from '../assets/icons/phoneGray.svg';
import mailIcon from '../assets/icons/emailGray.svg';
import ValidationSchema from '../helpers/ValidationSchema';
import SectionsInfo from '../components/SectionsInfo';
import Spinner from '../components/Spinner';
import { getContactUsPage } from '../store/actions/contactPage';
import removeHtmlTags from '../helpers/removeHtmlTags';
import { sendFiatBackRequest } from '../store/actions/sendFiatBack';

function ContactItem({
  icon, title, info, email, phone,
}) {
  return (
    <div className="contacts-item">
      <div className="contacts-item-title">
        <div className="contacts-item-image">
          <img src={icon} alt="icon" />
        </div>
        <p>{title}</p>
      </div>
      <div className="contacts-item-list">
        <div className="contacts-item-list-item">
          <p dangerouslySetInnerHTML={{ __html: info }} />
        </div>
      </div>
      <div className="contacts-item-contacts">
        <a href={`mailto:${email}`} className="contacts-item-contact">
          <img src={mailIcon} alt="mail" />
          <p>{email}</p>
        </a>
        <a href={`tel:${phone}`} className="contacts-item-contact">
          <img src={phoneIcon} alt="mail" />
          <p>{phone}</p>
        </a>
      </div>
    </div>
  );
}

function ContactUs() {
  const { messageSchema } = ValidationSchema();
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.contactPage);
  const [sending, setSending] = useState(false);
  const { translations, loading: loadingTranslation } = useSelector((state) => state.translation);
  useEffect(() => {
    dispatch(getContactUsPage());
  }, []);
  const handleSend = async (formData) => {
    setSending(true);
    const dataForSend = {
      full_name: formData.fullName,
      email: formData.email,
      message: formData.message,
      lang,
    };
    const { payload } = await dispatch(sendFiatBackRequest({ dataForSend, method: 'message' }));
    if (payload.message === 'Send message successfully.') {
      toast(translations.review_sent_successfully[lang]);
    }
    setSending(false);
  };
  return (
    <Wrapper>
      {(!loading && !loadingTranslation) ? (
        <div className="contact-us">
          <div className="container small">
            <div className="contact-us__form">
              <div className="contact-us__form-form">
                <div className="contact-us__form-form-info">
                  <h1>
                    {data.contactInfo.letsGetInTouch_title[lang]}
                    {/* <span>in touch</span> */}
                  </h1>
                  {/* <p> */}
                  {/*  {removeHtmlTags(data.contactInfo.letsGetInTouch_description[lang])} */}
                  {/* </p> */}
                </div>
                <Formik
                  initialValues={{
                    email: '',
                    fullName: '',
                    message: '',
                  }}
                  onSubmit={async (values, actions) => {
                    actions.setSubmitting(false);
                    await handleSend(values);
                    actions.resetForm();
                  }}
                  validationSchema={messageSchema}
                >
                  <Form className="register-form contact_us">
                    <div className="contact_us__inputs-row">
                      <div className="register-form-group">
                        <label className="inputs-label" htmlFor="fullName">{translations.full_name_label[lang]}</label>
                        <div className="register-form-group_input input-block contact">
                          <Field
                            as="input"
                            type="text"
                            name="fullName"
                            id="fullName"
                            placeholder={translations.full_name_placeholder[lang]}
                          />
                          <img src={userIcon} alt="user" className="contact-us__form-icon" />
                        </div>
                        <ErrorMessage
                          name="fullName"
                          component="p"
                          className="authError"
                        />
                      </div>
                      <div className="register-form-group">
                        <label className="inputs-label" htmlFor="email">{translations.email_label[lang]}</label>
                        <div className="register-form-group_input input-block contact">
                          <Field
                            as="input"
                            type="text"
                            name="email"
                            id="email"
                            placeholder={translations.email_placeholder[lang]}
                          />
                          <img src={messageIcon} alt="user" className="contact-us__form-icon" />

                        </div>
                        <ErrorMessage
                          name="email"
                          component="p"
                          className="authError"
                        />
                      </div>
                      <div className="register-form-group big">
                        <label className="inputs-label" htmlFor="message">
                          {translations.message_label[lang]}
                        </label>
                        <div className="register-form-group_input input-block">
                          <Field
                            as="textarea"
                            type="text"
                            name="message"
                            id="message"
                            placeholder={translations.message_placeholder[lang]}
                          />
                        </div>
                        <ErrorMessage
                          name="message"
                          component="p"
                          className="authError"
                        />
                      </div>
                    </div>
                    <button type="submit" className="question__form-btn">
                      {sending ? <Spinner isBtn width={30} height={30} size={30} /> : (
                        <>
                          <img src={sendIcon} alt="send request" />
                          {}
                          <p>{translations.send[lang]}</p>
                        </>
                      )}
                    </button>
                  </Form>
                </Formik>
              </div>
              <div className="contact-us__form-image">
                <img src={data.contactInfo.image.webp_url} alt="" />
              </div>
            </div>
            <div className="contact-us-contacts">
              <SectionsInfo
                isPartner={false}
                isSlider={false}
                title={removeHtmlTags(data.contactInfo.two_blog_title[lang])}
              />
              <div className="contacts_list">
                {data.contacts.map((e) => (
                  <ContactItem
                    key={e.id}
                    info={e.body[lang]}
                    icon={e?.image?.webp_url}
                    title={e.title[lang]}
                    email={e.email}
                    phone={e.phone}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default ContactUs;
